// Overview
import OverviewHeader from "@views/overview/components/OverviewHeader";
import Overview from "@views/overview/Overview";

// Access
import Access from "@views/access/Access";
import AccessHeader from "@views/access/components/AccessHeader";

// Advertising
import Advertising from "@views/advertising/Advertising";
import AdvertisingHeader from "@views/advertising/components/AdvertisingHeader";

// Apis
import Apis from "@views/apis/Apis";
import ApisHeader from "@views/apis/ApisHeader";

// Audtis
import Audits from "@views/audits/Audits";
import AuditsHeader from "@views/audits/components/AuditsHeader";

// Comments
import Comments from "@views/comments/Comments";
import CommentsHeader from "@views/comments/components/CommentsHeader";
import ConnectionsHeader from "@views/connections/components/ConnectionsHeader";

// Connections
import Connections from "@views/connections/Connections";
import FreeConnectionsHeader from "@views/free-connections/components/FreeConnectionsHeader";

// FreeConnections
import FreeConnections from "@views/free-connections/FreeConnections";
import IntegrationHeader from "@views/integration/components/IntegrationHeader";

// Promocional Code
import Integration from "@views/integration/Integration";
import InteractionsHeader from "@views/interactions/components/InteractionsHeader";

// Interactions
import LeadsAccessHeader from "@components/modules/leads/access/header/LeadsAccessHeader";
import LeadsExternalHeader from "@components/modules/leads/external/header/LeadsExternalHeader";
import Interactions from "@views/interactions/Interactions";

// Leads
import LeadsAccess from "@views/leads/access/LeadsAccess";
import LeadsExternal from "@views/leads/external/LeadsExternal";

//Locals
import LocalsHeader from "@views/locals/components/LocalsHeader";
import Locals from "@views/locals/Locals";

//establishment
import EstablishmentsHeader from "@views/admin/establishments/components/EstablishmentsHeader";
import Establishments from "@views/admin/establishments/Establishments";

// Marketing
import MarketingSmsCreateHeader from "@views/marketing/sms/create/components/MarketingSmsCreateHeader";
import MarketingSmsCreate from "@views/marketing/sms/create/MarketingSmsCreate";
import MarketingSmsEdit from "@views/marketing/sms/edit/MarketingSmsEdit";
import MarketingSmsEditHeader from "@views/marketing/sms/edit/MarketingSmsEditHeader";
import MarketingAutomationDetailHeader from "@components/modules/marketing/automation/detail/header/MarketingAutomationDetailHeader";
import MarketingAutomationHeader from "@components/modules/marketing/automation/header/MarketingAutomationHeader";
import MarketingEmailHeaderCreate from "@components/modules/marketing/email/header/create/MarketingEmailHeaderCreate";
import MarketingEmailHeaderEdit from "@components/modules/marketing/email/header/edit/MarketingEmailHeaderEdit";
import MarketingEmailHeader from "@components/modules/marketing/email/header/MarketingEmailHeader";
import MarketingWhatsappHeader from "@components/modules/marketing/whatsapp/header/MarketingWhatsappHeader";
import MarketingAutomationDetail from "@views/marketing/automation/detail/MarketingAutomationDetail";
import MarketingAutomation from "@views/marketing/automation/MarketingAutomation";
import MarketingEmailCreateContent from "@views/marketing/email/create/content/MarketingEmailCreateContent";
import MarketingEmailCreateModel from "@views/marketing/email/create/model/MarketingEmailCreateModel";
import MarketingEmailCreateRecipients from "@views/marketing/email/create/recipients/MarketingEmailCreateRecipients";
import MarketingEmailCreateSend from "@views/marketing/email/create/send/MarketingEmailCreateSend";
import MarketingEmailCreateVerify from "@views/marketing/email/create/verify/MarketingEmailCreateVerify";
import MarketingEmailEditContent from "@views/marketing/email/edit/content/MarketingEmailEditContent";
import MarketingEmailEditRecipients from "@views/marketing/email/edit/recipients/MarketingEmailEditRecipients";
import MarketingEmailEditSend from "@views/marketing/email/edit/send/MarketingEmailEditSend";
import MarketingEmailEditVerify from "@views/marketing/email/edit/verify/MarketingEmailEditVerify";
import MarketingEmail from "@views/marketing/email/MarketingEmail";
import MarketingSms from "@views/marketing/sms/MarketingSms";
import MarketingSmsHeader from "@views/marketing/sms/MarketingSmsHeader";
import MarketingSmsView from "@views/marketing/sms/view/MarketingSmsView";
import MarketingSmsViewHeader from "@views/marketing/sms/view/MarketingSmsViewHeader";
import MarketingWhatsapp from "@views/marketing/whatsapp/MarketingWhatsapp";

//Promotional Code
import PromocionalCodeHeader from "@views/promocional-code/components/PromocionalCodeHeader";

// Integration
import PromocionalCode from "@views/promocional-code/PromocionalCode";
import SettingsHeader from "@views/settings/components/SettingsHeader";

// Settings
import Settings from "@views/settings/Settings";

// Statistics
import Statistics from "@views/statistics/Statistics";
import StatisticsHeader from "@views/statistics/components/StatisticsHeader";

//Usage Terms
import UsageTermsHeader from "@views/usage-terms/components/UsageTermsHeader";
import UsageTerms from "@views/usage-terms/UsageTerms";
import UsageTermsCreate from "@views/usage-terms/UsageTermsCreate";
import UsageTermsEdit from "@views/usage-terms/UsageTermsEdit";
import UsersHeader from "@views/users/components/UsersHeader";

// Login Personalize
import LoginPersonalizeHeader from "@components/modules/login-personalize/header/LoginPersonalizeHeader";
import LoginPersonalizeDetailPage from "@views/login-personalize/detail/LoginPersonalizeDetailPage";
import LoginPersonalizePage from "@views/login-personalize/LoginPersonalizePage";

//BusinessHours
import BusinessHours from "@views/business-hours/BusinessHours";
import BusinessHoursHeader from "@views/business-hours/header/BusinessHoursHeader";

//CaptiveForms
import CaptiveForms from "@views/captive-forms/CaptiveForms";
import CaptiveFormsHeader from "@views/captive-forms/header/CaptiveFormsHeader";

//Trackers
import TrackerHeader from "@views/tracker/header/TrackerHeader";
import Tracker from "@views/tracker/Tracker";

//Users
import Users from "@views/users/Users";

//Vouchers
import VoucherPageHeader from "@views/voucher/header/VoucherPageHeader";
import VoucherPage from "@views/voucher/VoucherPage";

//System Communications
import SystemCommunications from "@views/system-communications/SystemCommunications";
import SystemCommunicationsHeader from "@views/system-communications/header/SystemCommunicationsHeader";
import SystemCommunicationsEmail from "@views/system-communications/email/SystemCommunicationsEmail";
import SystemCommunicationsEmailHeader from "@views/system-communications/email/header/SystemCommunicationsEmailHeader";
import MonitoringTrafficHeader from "@views/monitoring/traffic/header/MonitoringTrafficHeader.vue";
import MonitoringTraffic from "@views/monitoring/traffic/MonitoringTraffic.vue";
import { redirectUtils } from "../../util/redirect/redirectUtils";

export default [
  {
    name: "Overview",
    path: "/visao-geral",
    components: {
      default: Overview,
      header: OverviewHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/visao-geral'))
    }
  },

  {
    name: "Statistics",
    path: "/estatisticas",
    meta: { requiresAuth: true },
    components: {
        default: Statistics,
        header: StatisticsHeader,
    },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/estatisticas'))
    }
  },

  {
    name: "monitoring-traffic",
    path: "/monitoramento/trafego",
    meta: { requiresAuth: true },
    components: {
        default: MonitoringTraffic,
        header: MonitoringTrafficHeader
    },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/monitoramento/trafego'))
    }
  },

  {
    name: "Establishment_parceiros",
    path: "/estabelecimentos",
    components: {
      default: Establishments,
      header: EstablishmentsHeader,
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Cadastros",
    path: "/cadastros/acessos",
    components: {
      default: LeadsAccess,
      header: LeadsAccessHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/cadastros/acessos'))
    }
  },

  {
    name: "Cadastros",
    path: "/cadastros/importacoes",
    components: {
      default: LeadsExternal,
      header: LeadsExternalHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/cadastros/importacoes'))
    }
  },

  {
    name: "Advertising",
    path: "/campanhas",
    components: {
      default: Advertising,
      header: AdvertisingHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "INTERACTIONS",
    path: "/campanhas/:id/interacoes",
    components: {
      default: Interactions,
      header: InteractionsHeader,
    },
    meta: { requiresAuth: true },
  },

  // {
  //     name: 'Help',
  //     path: '/ajuda',
  //     component: Overview,
  //     meta: {requiresAuth: false}
  // },

  {
    name: "Comments",
    path: "/comentarios",
    components: {
      default: Comments,
      header: CommentsHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/comentarios'))
    }
  },

  {
    name: "Connections",
    path: "/conexoes",
    components: {
      default: Connections,
      header: ConnectionsHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/conexoes'))
    }
  },

  {
    name: "FreeConnections",
    path: "/conexoes-liberadas",
    components: {
      default: FreeConnections,
      header: FreeConnectionsHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "Settings",
    path: "/configuracoes",
    components: {
      default: Settings,
      header: SettingsHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "Integration",
    path: "/integration",
    components: {
      default: Integration,
      header: IntegrationHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/integracoes'))
    }
  },

  {
    name: "PromocionalCode",
    path: "/codigo-promocional",
    components: {
      default: PromocionalCode,
      header: PromocionalCodeHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "Acessos",
    path: "/acessos",
    components: {
      default: Access,
      header: AccessHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "Locals",
    path: "/locais",
    components: {
      default: Locals,
      header: LocalsHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/locais'))
    }
  },

  {
    name: "Audits",
    path: "/auditorias",
    components: {
      default: Audits,
      header: AuditsHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "Users",
    path: "/usuarios",
    components: {
      default: Users,
      header: UsersHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "System Communications",
    path: "/system-communications",
    components: {
      default: SystemCommunications,
      header: SystemCommunicationsHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter: () => {
      location.assign(redirectUtils.mountUrl('/new/parceiro/configuracoes/comunicacoes'))
    }
  },

  {
    path: "/system-communications/email",
    components: {
      default: SystemCommunicationsEmail,
      header: SystemCommunicationsEmailHeader,
    },
    meta: { requiresAuth: true },
    children: [
      {
        name: "System Communications Email Welcome",
        path: "welcome",
      },
      {
        name: "System Communications Email Password Recovery",
        path: "password-recovery",
      },
    ],
  },

  {
    name: "Apis",
    path: "/apis",
    components: {
      default: Apis,
      header: ApisHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/apis'))
    }
  },

  {
    name: "Marketing",
    path: "/marketing/sms",
    components: {
      default: MarketingSms,
      header: MarketingSmsHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/sms'))
    }
  },

  {
    name: "MarketingSend",
    path: "/marketing/sms/criar",
    components: {
      default: MarketingSmsCreate,
      header: MarketingSmsCreateHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/sms'))
    }
  },

  {
    name: "MarketingEdit",
    path: "/marketing/editar-envio/:smsId",
    components: {
      default: MarketingSmsEdit,
      header: MarketingSmsEditHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/sms'))
    }
  },

  {
    name: "MarketingView",
    path: "/marketing/vizualizar/:smsId",
    components: {
      default: MarketingSmsView,
      header: MarketingSmsViewHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/sms'))
    }
  },

  {
    name: "UsageTerms",
    path: "/termos-de-uso",
    components: {
      default: UsageTerms,
      header: UsageTermsHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/termos-de-uso'))
    }
  },

  {
    name: "UsageTerms",
    path: "/termos-de-uso/editar/:usageTermId",
    components: {
      default: UsageTermsEdit,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/termos-de-uso'))
    }
  },

  {
    name: "UsageTermsCreate",
    path: "/termos-de-uso/cadastrar",
    components: {
      default: UsageTermsCreate,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/termos-de-uso'))
    }
  },

  {
    name: "Marketing Email",
    path: "/marketing/email",
    components: {
      default: MarketingEmail,
      header: MarketingEmailHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Email Create Model",
    path: "/marketing/email/criar/modelo",
    components: {
      default: MarketingEmailCreateModel,
      header: MarketingEmailHeaderCreate,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Email Create Content",
    path: "/marketing/email/criar/conteudo",
    components: {
      default: MarketingEmailCreateContent,
      header: MarketingEmailHeaderCreate,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Email Create Recipients",
    path: "/marketing/email/criar/destinatarios",
    components: {
      default: MarketingEmailCreateRecipients,
      header: MarketingEmailHeaderCreate,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Email Create Verify",
    path: "/marketing/email/criar/verificacao",
    components: {
      default: MarketingEmailCreateVerify,
      header: MarketingEmailHeaderCreate,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Email Create Verify",
    path: "/marketing/email/criar/envio",
    components: {
      default: MarketingEmailCreateSend,
      header: MarketingEmailHeaderCreate,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Email Create Content",
    path: "/marketing/email/editar/:emailId/conteudo",
    components: {
      default: MarketingEmailEditContent,
      header: MarketingEmailHeaderEdit,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Email Create Recipients",
    path: "/marketing/email/editar/:emailId/destinatarios",
    components: {
      default: MarketingEmailEditRecipients,
      header: MarketingEmailHeaderEdit,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Email Create Verify",
    path: "/marketing/email/editar/:emailId/verificacao",
    components: {
      default: MarketingEmailEditVerify,
      header: MarketingEmailHeaderEdit,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Email Create Verify",
    path: "/marketing/email/editar/:emailId/envio",
    components: {
      default: MarketingEmailEditSend,
      header: MarketingEmailHeaderEdit,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/email'))
    }
  },

  {
    name: "Marketing Automation",
    path: "/marketing/automacao",
    components: {
      default: MarketingAutomation,
      header: MarketingAutomationHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "Marketing Automation",
    path: "/marketing/automacao/:automationId",
    components: {
      default: MarketingAutomationDetail,
      header: MarketingAutomationDetailHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "Captive Forms",
    path: "/captive-forms",
    components: {
      default: CaptiveForms,
      header: CaptiveFormsHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/cadastros/formularios'))
    }
  },

  {
    name: "Trackers",
    path: "/tracker",
    components: {
      default: Tracker,
      header: TrackerHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/rastreadores'))
    }
  },

  {
    name: "Voucer",
    path: "/voucher",
    components: {
      default: VoucherPage,
      header: VoucherPageHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/vouchers'))
    }
  },

  {
    name: "Business Hours",
    path: "/business-hours",
    components: {
      default: BusinessHours,
      header: BusinessHoursHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/configuracoes/horario'))
    }
  },

  {
    name: "LoginForms",
    path: "/personalizar-login",
    components: {
      default: LoginPersonalizePage,
      header: LoginPersonalizeHeader,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "LoginPersonalize",
    path: "/personalizar-login/:id",
    components: {
      default: LoginPersonalizeDetailPage,
    },
    meta: { requiresAuth: true },
  },

  {
    name: "Marketing",
    path: "/marketing/whatsapp",
    components: {
      default: MarketingWhatsapp,
      header: MarketingWhatsappHeader,
    },
    meta: { requiresAuth: true },
    beforeEnter() {
      location.assign(redirectUtils.mountUrl('/new/estabelecimento/marketing/whatsapp'))
    }
  },
];
